import React from 'react';

import InfinitelyScrolled from '../InfinitelyScrolled';
import { InfinitelyScrolledConsumer } from '../InfinitelyScrolled/interfaces';

interface ListProps extends InfinitelyScrolledConsumer {
  Shimmers: any;
  // NOTE: Making required because of conditional rendering logic.
  children: React.ReactNode;
}

const List = ({ Shimmers, onLoadMore, hasMore, children }: ListProps) => {
  return children ? (
    <InfinitelyScrolled
      initialLoad={false}
      loadMore={onLoadMore}
      hasMore={hasMore}
      threshold={2000}
      loader={<Shimmers key={0} />}
      useWindow={false}
    >
      {children}
    </InfinitelyScrolled>
  ) : null;
};
export default List;
